import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import SearchIcon from '@mui/icons-material/Search';
import {
  SearchIconBox,
  SearchIconWrapper,
  SearchInputBase,
  SearchWrapper,
} from '@tenant/core/AppSearchBar/index.style';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import ClearIcon from '@mui/icons-material/Clear';
const SearchPermission = ({
  placeholder,
  iconPosition,
  align,
  overlap,
  onlyIcon,
  disableFocus,
  iconStyle,
  isClearable,
  searchValue,
  onClearSearch,
  isResetSearch = false,
  ...rest
}) => {
  return (
    <SearchWrapper sx={rest.sx} iconPosition={iconPosition}>
      <SearchIconBox
        align={align}
        className={clsx(
          'searchRoot',
          { 'hs-search': overlap },
          { 'hs-disableFocus': disableFocus },
          { searchIconBox: onlyIcon },
        )}
      >
        <SearchIconWrapper
          className={clsx({
            right: true,
          })}
          style={{ ...iconStyle, pointerEvents: isClearable ? 'auto' : 'none' }}
        >
          {isClearable &&
            (searchValue ? (
              <Tooltip title='Clear'>
                <span>
                  <IconButton disabled={!searchValue} onClick={clearSearch}>
                    <ClearIcon />
                  </IconButton>
                </span>
              </Tooltip>
            ) : (
              <SearchIcon />
            ))}

          {!isClearable && <SearchIcon />}
        </SearchIconWrapper>
        <SearchInputBase
          placeholder={placeholder || 'Search…'}
          inputProps={{ 'aria-label': 'search' }}
          value={searchValue}
          {...rest}
        />
      </SearchIconBox>
    </SearchWrapper>
  );
};

export default React.memo(SearchPermission);

SearchPermission.propTypes = {};
